import { NgModule } from '@angular/core';
import { PulsatingDirective } from './pulsating.directive';

@NgModule({
    declarations: [
        PulsatingDirective
    ],
    imports: [],
    exports: [
        PulsatingDirective
    ]
})
export class NcPulsatingModule { }